<template>
  <div class="eaz_0">
    <div v-for="(item,index) in eqInfoList" :key="index">
      <div class="div2" v-show="index ==0">
        <h4 class="title">调账记录</h4>
        <ul class="ul" v-show="index ==0">
          <li>
            <div>调账人名称：</div>
            <div>{{item.adjustName}}</div>
          </li>
          <li>
            <div>调后商品价格：</div>
            <div>￥{{item.adjustAfterPrice}}</div>
          </li>
          <li>
            <div>调账差价：</div>
            <div>{{adjustTypeText[item.adjustType]}}￥{{item.actualPrice}}</div>
          </li>
          <li>
            <div> 调账时间：</div>
            <div>{{item.adjustTime}}</div>
          </li>
          <li>
            <div>是否调账完成：</div>
            <div>{{item.isInProcessing && item.isInProcessing == '1' ? payText : item.orderStatus}}</div>
          </li>
        </ul> 
        <van-button v-show="item.isInProcessing && item.isInProcessing == '1'" class="btn" :loading="loading" @click="goPay(item.adjustOrderId)">待补款</van-button>
      </div>
      <div class="div2" v-show="index >0 && open">
        <h4 class="title">调账记录</h4>
        <ul class="ul">
          <li>
            <div>调账人名称：</div>
            <div>{{item.adjustName}}</div>
          </li>
          <li>
            <div>调后商品价格：</div>
            <div>￥{{item.adjustAfterPrice}}</div>
          </li>
          <li>
            <div>调账差价：</div>
            <div>{{adjustTypeText[item.adjustType]}}￥{{item.actualPrice}}</div>
          </li>
          <li>
            <div> 调账时间：</div>
            <div>{{item.adjustTime}}</div>
          </li>
          <li>
            <div>是否调账完成：</div>
            <div>{{item.orderStatus}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer" v-show="eqInfoList.length > 1" @click="eqInfoList.length > 1 && (open = !open)">{{footerText[open]}}</div>
  </div>
</template>
<script>
import Util from "@/utils/common";
import http from "@/utils/axios";

export default {
  name: 'SetRepair',
  props: {
    
  },
  data() {
    return {
      message:'',
      value:'',
      radio:'1',
      sureLoading: false,
      loading: false,
      open: false,
      footerText:{
        true: '点击收起',
        false: '点击展开更多'
      },
      eqInfoList:[],
      gitemid: this.$route.query.gitemid,
      orderId:'',
      eqObj:{},
      payText: '未支付',
      adjustTypeText:{
        '2':'退款',
        '1':'补款'
      }
    }
  },
  methods: {
    eqInit(){
      http({
        url: "order/app/adjustOrder/" + this.gitemid,
        method: "get"
      }).then(rps => {
        if (rps.code === 200) {
          let obj = {}
          for (const key in rps.data) {
            if (key != 'adjustRecordList') {
              obj[key] = rps.data[key];
            }
          }
          this.eqObj = obj
          this.eqInfoList = rps.data.adjustRecordList || []
          if(rps.data.isInProcessing && rps.data.isInProcessing == '1'){
            this.eqInfoList.unshift(this.eqObj)
          }
          this.$loading.hide()
        }
      }).catch(err=>{
        this.$loading.hide()
      });
    },
    goPay(adjustOrderId){
      Util.callPay(adjustOrderId)
    },
  },
  created() {
    this.eqInit()
  },
  watch:{},
  destroyed(){},
  mounted(){},
  computed:{},
  components: {},
};
</script>
<style lang="less" scoped>
.eaz_0{
  font-size: 24px;
  color: #333333;
  background: #F7F7F7;
  .mar5{
    margin-top: 20px;
  }
  .mar10{
    margin-top: 35px;
  }
  .div2{
    margin: 30px 30px;
    border-radius: 20px;
    background: #ffffff;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 25px;
    padding-bottom: 20px;
    .title{
      font-size: 26px;
      color: #333333;
      margin-top: 20px;
      margin-bottom: 20px;
      font-weight: 500;
    }
    .ul{
      >li{
        margin-bottom: 17px;
        display: flex;
        justify-content: space-between;
      }
    }
    .btn{
      width: 160px;
      height: 60px;
      background: #F8D541;
      border-radius: 32px;
      line-height: 60px;
      text-align: center;
      color: #333333;
      margin: 0 auto;
      margin-top: 20px;
      display: block;
      border:0px;
    }
  }
  .footer{
    width: 300px;
    height: 50px;
    background: #FFFFFF;
    border-radius: 32px;
    border: 1px solid #999999;
    line-height: 50px;
    text-align: center;
    color: #999999;
    margin: 0 auto;
    margin-top: 20px;
    display: block;
  }
}
</style>